import { handleFetchAll } from 'streams/crud/routines';
import { fieldNamespace } from './actions';
import { fieldApi } from '@ardoq/api';
import { collectRoutines } from '@ardoq/rxbeach';

export const routines = collectRoutines(
  handleFetchAll(fieldNamespace, fieldApi.fetchAll)
);
